module.exports = __webpack_public_path__ + "8a5356e9/img/grid-web-icon.d0395d64.svg";